import React from 'react';
import { useTeampageTranslations } from '@/hooks/useTeampageTranslations';

const ROLE_COLORS: Record<string, string> = {
  Admin: 'bg-blue-100 text-blue-800',
  Editor: 'bg-green-100 text-green-800',
  Viewer: 'bg-gray-100 text-gray-800',
  OrgOwner: 'bg-purple-100 text-purple-800',
};

interface RoleBadgeProps {
  role: string;
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  const i18n = useTeampageTranslations();
  const classes = ROLE_COLORS[role] || 'bg-gray-100 text-gray-800';

  // Type-safe role translation access
  const translatedRole =
    role === 'Admin' || role === 'Editor' || role === 'Viewer' || role === 'OrgOwner'
      ? i18n.roles[role]?.name || role
      : role;

  return (
    <span className={`${classes} rounded-full px-2 py-1 text-sm font-medium`}>
      {translatedRole}
    </span>
  );
};
